<template>
  <div class="dx-card-actions">
    <div class="text-center">
      <dx-button @click.native="$emit('hit')" success large :disabled="disabledActions">
        {{ $t('hit') }}
      </dx-button>
      <dx-button @click.native="$emit('missed')" link large :disabled="disabledActions">
        {{ $t('missed') }}
      </dx-button>
      <dx-report-tip @click.native="reportTip" v-if="false" />
      <div class="text-center" v-if="showRollback">
        <dx-button @click.native="$emit('rollback')" link small>
          {{ $t('rollback') }}
        </dx-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DxButton from './DxButton.vue'
import DxReportTip from './DxReportTip.vue'
export default {
  name: 'dx-card-actions',
  props: {
    itemId: Number,
    disabledActions: false
  },
  components: { DxButton, DxReportTip },
  computed: {
    ...mapGetters({
      turn: 'getTurn'
    }),
    showRollback () {
      return this.turn > 1
    }
  },
  methods: {
    reportTip () {
      this.$emit('open-report-modal', this.itemId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardActions.vue